import axios, { AxiosResponse, AxiosError, AxiosRequestConfig } from "axios";

// Requests go through our own /api/proxy route, which injects the real backend
// credentials server-side — the browser bundle never sees them.
const host = "/api/proxy";

const axiosClient = axios.create({
    baseURL: host,
});

// Add response interceptor to handle token refresh

// Utility to handle responses consistently
async function handleRequest<T>(promise: Promise<AxiosResponse<T>>): Promise<AxiosResponse<T>> {
    try {
        const response = await promise; // Successful request
        return response; // Return the full Axios response
    } catch (error) {
        const axiosError = error as AxiosError;
        if (axiosError.response) {
            // Server responded with a non-2xx status code
            return axiosError.response as AxiosResponse<T>; // Return the error response
        }
        console.error("Network or unexpected error:", axiosError.message, {
            method: axiosError.config?.method,
            url: axiosError.config?.url,
            baseURL: axiosError.config?.baseURL,
            params: axiosError.config?.params,
        });
        throw new Error("Network error or no response from server.");
    }
}

interface RequestParams {
    endpoint: string;
    headers?: Record<string, string>;
}

interface BodyRequestParams extends RequestParams {
    body?: any;
}

interface StreamRequestParams extends BodyRequestParams {
    onStream?: (progressEvent: any) => void;
}

export function baseGet<T>({ endpoint, headers }: RequestParams): Promise<AxiosResponse<T>> {
    return handleRequest<T>(axiosClient.get(endpoint, { headers }));
}

export function basePost<T>({ endpoint, headers, body }: BodyRequestParams): Promise<AxiosResponse<T>> {
    return handleRequest<T>(axiosClient.post(endpoint, body, { headers }));
}

// Handle Stream request (onStream is passed from outside)
export async function basePostStream<T>({ endpoint, headers, body, onStream }: StreamRequestParams): Promise<AxiosResponse<T>> {
    return handleRequest<T>(
        axios({
            method: "post",
            headers,
            url: host + endpoint,
            data: body,
            responseType: "stream",
            onDownloadProgress: onStream,
        })
    );
}

export function basePut<T>({ endpoint, headers, body }: BodyRequestParams): Promise<AxiosResponse<T>> {
    return handleRequest<T>(axiosClient.put(endpoint, body, { headers }));
}

export function basePatch<T>({ endpoint, headers, body }: BodyRequestParams): Promise<AxiosResponse<T>> {
    return handleRequest<T>(axiosClient.patch(endpoint, body, { headers }));
}

export function baseDelete<T>({ endpoint, headers }: RequestParams): Promise<AxiosResponse<T>> {
    return handleRequest<T>(axiosClient.delete(endpoint, { headers }));
}